/**
 * RESPONSIBILITY: who may open the contact-requests page and work what is on it.
 *
 * ONE definition, read by the endpoints and by the page. The endpoints are the lock and
 * the page is a courtesy, but a rule written twice drifts - one of them ends up letting
 * somebody in that the other would turn away. Here is the only place it is said.
 *
 * Whoever may open the page may do everything on it - archive a request, put it back, and
 * write the note - because the welcome team is who follows visitors up, and following up
 * is exactly that. `admin` is the framework's bypass and is always included.
 */
import { Role } from '../roles';

type Roles = readonly string[] | undefined;

export const canSeeRequests = (roles: Roles): boolean =>
  !!roles && (roles.includes(Role.Admin) || roles.includes(Role.Welcome));
